import colors from '@lmc/common/constants'
import React from 'react'

const OverdueIcon = (
  <>
    <path
      d="M20.6922 11.3086L20.694 11.3103C21.102 11.7163 21.102 12.2837 20.694 12.6898L20.6922 12.6915L12.6915 20.6923L12.6897 20.694C12.2837 21.1021 11.7163 21.1021 11.3103 20.694L11.3085 20.6923L3.30775 12.6915L3.30602 12.6898C2.89799 12.2837 2.89799 11.7163 3.30602 11.3103L3.30775 11.3086L11.3085 3.30775L11.3103 3.30602C11.7163 2.89799 12.2837 2.89799 12.6897 3.30602L12.6915 3.30775L20.6922 11.3086Z"
      stroke="#fba423"
      strokeWidth="2"
      fill={colors.white}
    />
    <line
      x1="12"
      y1="7"
      x2="12"
      y2="13"
      stroke={colors.orange}
      strokeWidth="2"
    />
    <line
      x1="12"
      y1="15"
      x2="12"
      y2="17"
      stroke={colors.orange}
      strokeWidth="2"
    />
  </>
)

export default OverdueIcon
